module.exports = {
    ENV :{
       API_URL: 'https://nft-marketeplace-fkg7q.ondigitalocean.app/',
        API_URL_image: 'https://nft-marketeplace-fkg7q.ondigitalocean.app',
        API_URL_image_media: 'https://nft-marketeplace-fkg7q.ondigitalocean.app/media/',
        // API_URL:'http://192.168.99.138:8005/'
    }
}